const EventEmitter = require('events'); 
const {Character} = require('../lib/character.js');
const {campaign,sleep, upgradeItem,globalDataListener,areSameDeep,areSameDeepInst,areSameDeepIgnore,areSameDeepDebug} = require('../lib/campaign.js');
const {addConditionInfoToConditions} = require('./conditions.jsx');
const {getTokenInfo,addMonsters,MonsterTokenSelect,Combatant,findFreeSpot,fixupCombatants} = require('./encountermonsterlist.jsx');
const {sizeScaleMap} = require('../lib/stdvalues.js');

class EncounterCombatants {
    constructor (name, playerView,readonly) {
        this.name = name;
        this.playerView = playerView;
        this.onCombatantsChange = this.onCombatantsChange.bind(this);
        this.onOtherChange = this.onOtherChange.bind(this);
        this.eventSync = new EventEmitter();
        this.campaignVersion = (name == "campaign");
        this.readonly = readonly;

        if (this.campaignVersion) {
            globalDataListener.onChangeCampaignContent(this.onCombatantsChange, "adventure");
            globalDataListener.onChangeCampaignContent(this.onOtherChange, "players");
        } else {
            globalDataListener.onChangeCampaignContent(this.onCombatantsChange, "plannedencounters");

        }
        globalDataListener.onChangeCampaignContent(this.onOtherChange, "monsters");
        this.selected = {};
        this.load();
    }

    destroy() {
        if (this.campaignVersion) {
            globalDataListener.removeCampaignContentListener(this.onCombatantsChange, "adventure");
            globalDataListener.removeCampaignContentListener(this.onOtherChange, "players");
        } else {
            globalDataListener.removeCampaignContentListener(this.onCombatantsChange, "plannedencounters");
        }
        globalDataListener.removeCampaignContentListener(this.onOtherChange, "monsters");
        this.delay && clearTimeout(this.delay);
        this.eventSync.removeAllListeners();
    }

    changeEncounter(name) {
        if (this.name == name) {
            return;
        }
        if ((this.name == "campaign") || (name=="campaign")) {
            throw (new Error("cannot change from campaign"))
        }

        this.name=name;
        this.selected = {}
        this.load();
        this.eventSync.emit("change");
    }

    onCombatantsChange() {
        this.needLoad=1;
        this.delayChange();
    }

    delayChange() {
        if (!this.delay) {
            this.delay = setTimeout(this.doUpdate.bind(this),10);
        }
    }

    doUpdate(force) {
        let old;
        this.delay=null;
        if (this.needLoad||force) {
            old=this.combatants;
            this.load();
            this.needLoad=0;
        }
        if (this.alwaysLoad, !areSameDeep(old, this.combatants)) {
            this.eventSync.emit("change");
            this.alwaysLoad=0;
        }
    }

    onOtherChange() {
        this.alwaysLoad=1;
        this.delayChange();
    }

    load() {
        let combatants = [];
        if (this.campaignVersion) {
            const adventure = campaign.getAdventure();
            const positions = adventure.positions;
            combatants = adventure.combatants || [];
            this.version = adventure.timestamp;

            if (positions) {
                combatants = combatants.concat();

                for (let i in combatants) {
                    let c = combatants[i];
                    const p = positions[c.id];
                    if (p) {
                        c = Object.assign({},c);
                        combatants[i]=c;
                        c.tokenX=p.tokenX;
                        c.tokenY=p.tokenY;
                        if ((c.tokenX==Number.POSITIVE_INFINITY) || (c.tokenY==Number.POSITIVE_INFINITY)) {
                            c.tokenMap=null;
                        }
                        if (p.rotation != null) {
                            c.rotation=p.rotation;
                        } else {
                            delete c.rotation;
                        }
                    }
                }
            }
        } else {
            const encounter = campaign.getPlannedEncounterInfo(this.name);
            if (encounter) {
                combatants = encounter.combatants||[];

                for (let c of combatants) {
                    delete (c||{}).cInfo;
                }
                this.version = encounter.timestamp;
            }
        }
        //console.log("load combatants", combatants)
        this.combatants=combatants;
        if (this.selected) {
            for (let id in this.selected) {
                const index = combatants.findIndex(function (c) {return c.tokenMap && (c.id==id)});
                if (index < 0) {
                    delete this.selected[id];
                }    
            }
        }
    }

    getCombatant(id) {
        const combatants = this.combatants || [];
        for (let c of combatants) {
            if (c.id == id) {
                return c;
            }
        }
        return null;
    }

    setCombatant(cInfo, disallowAdd) {
        const combatants = this.combatants.concat([]);
        const index = combatants.findIndex(function (c) {return c.id==cInfo.id});
        if (index >=0) {
            combatants[index] = cInfo;
        } else if (!disallowAdd) {
            combatants.push(cInfo);
        }
        this.changeCombatants(combatants);
    }

    deleteCombatant(id) {
        const combatants = this.combatants.concat([]);
        const index = combatants.findIndex(function (c) {return c.id==id});
        if (index >=0) {
            combatants.splice(index,1);
            this.changeCombatants(combatants);
        }
    }

    deleteSelected() {
        const combatants = this.combatants.concat([]);
        for (let id in this.selected) {
            const index = combatants.findIndex(function (c) {return c.id==id});
            if (index >=0) {
                combatants.splice(index,1);
            }    
        }
        this.changeCombatants(combatants);
        this.select();
    }

    updateSelected(field, val) {
        const combatants = this.combatants.concat([]);
        for (let i in combatants) {
            if (this.selected[combatants[i].id]) {
                const c = Object.assign({}, combatants[i]);
                c[field]=val;
                combatants[i] = c;
            }
        }
        this.changeCombatants(combatants);
    }

    adjustSelectedHP(adjust) {
        const combatants = this.combatants.concat([]);
        let changed;

        for (let i in combatants) {
            let cInfo = combatants[i];
            if (this.selected[cInfo.id]) {
                const crow = new Combatant(cInfo);
                cInfo = crow.adjustValue("hp", null, adjust,this.campaignVersion)
                if (cInfo) {
                    changed=true;
                    combatants[i] = cInfo;
                }
            }
        }
        if (changed) {
            this.changeCombatants(combatants);
        }
    }

    addConditionSelected(conditionInfo) {
        const combatants = this.combatants.concat([]);
        let changed;

        for (let i in combatants) {
            let cInfo = combatants[i];
            if (this.selected[cInfo.id]) {
                const crow = new Combatant(cInfo);

                let c = Object.assign({}, crow.conditions||{});
                addConditionInfoToConditions(c, conditionInfo);
    
                cInfo = crow.changeValue("conditions", c)
                if (cInfo) {
                    changed=true;
                    combatants[i] = cInfo;
                }
            }
        }
        if (changed) {
            this.changeCombatants(combatants);
        }
    }

    doHuddle(mapPos, group) {
        const amap = this.getAnchorOffsets();
        const combatants = this.combatants.concat([]);
        const list = [];

        for (let i in combatants) {
            const ci = combatants[i];
            const cInfo = (new Combatant(ci)).cInfo;

            if ((group == cInfo.group)&&((ci.state||"active")=="active")) {
                const c = Object.assign({}, combatants[i]);
                c.tokenMap = mapPos.mapName;
                findFreeSpot(mapPos.mapName, combatants, mapPos.x, mapPos.y, c, i)
                combatants[i] = c;
                list.push(c.id);
            }
        }
        this.setAnchorOffsets(combatants, amap);
        this.changeCombatants(combatants);
        this.select(list);
    }

    getAnchorOffsets() {
        const amap = {};

        for (let c of this.combatants) {
            if (c.anchorId) {
                const ac = this.getCombatant(c.anchorId);
                if (ac && ((ac.tokenMap||"").toLowerCase() == (c.tokenMap||"").toLowerCase())) {
                    amap[c.id] = {x:Number(c.tokenX)-Number(ac.tokenX), y:Number(c.tokenY)-Number(ac.tokenY)};
                }
            }
        }
        return amap;
    }

    setAnchorOffsets(combatants, amap) {
        let changed = true;
        while (changed) {
            changed=false;

            for (let c of combatants) {
                const offset = amap[c.id];
                if (offset && c.anchorId) {
                    const ac = combatants.find(function (t) {return t.id==c.anchorId});
                    if (ac && ac.tokenMap) {
                        const newX = Number(ac.tokenX)+offset.x,
                        newY = Number(ac.tokenY)+offset.y;

                        if ((c.tokenX != newX) || (c.tokenY != newY)) {
                            c.tokenMap == ac.tokenMap;

                            c.tokenX = Number(ac.tokenX)+offset.x;
                            c.tokenY = Number(ac.tokenY)+offset.y;
                            changed = true;
                        }
                    }
                }
            }
        }

    }

    selectGroup(group) {
        const combatants = this.combatants;
        const list = [];

        for (let i in combatants) {
            const ci = combatants[i];
            const cInfo = (new Combatant(ci)).cInfo;

            if ((group == cInfo.group)&&((ci.state||"active")=="active")) {
                list.push(ci.id);
            }
        }
        this.select(list);
    }

    changeCombatants(newC) {
        //console.log("change combatants", newC, this.selected)
        if (this.campaignVersion) {
            const adventure = Object.assign({},campaign.getAdventure());
            fixupCombatants(newC)
            adventure.combatants = newC;
            delete adventure.positions;
            if (this.playerView) {
                campaign.versionUpdateCampaignContent("adventure", adventure);
            } else {
                campaign.updateCampaignContent("adventure", adventure);
            }
        } else {
            const encounter = campaign.getPlannedEncounterInfo(this.name);
            if (encounter) {
                for (let e of newC||[]) {
                    delete (e||{}).cInfo;
                }
        
                encounter.combatants = newC;
                campaign.updateCampaignContent("plannedencounters", encounter);
            } else {
                console.log("encounter not found for update", this.name);
            }
        }
        this.combatants = newC;
        this.eventSync.emit("change");
    }

    changeCombatantPositions(vals) {
        //console.log("change pos", vals);
        const combatants = this.combatants.concat([]);
        const update={};

        for (let i in vals) {
            const a = vals[i];
            const index = combatants.findIndex(function (c) {return c.id == a.id});
            if (index>=0) {
                const c = Object.assign({},combatants[index]);
                combatants[index]=c;

                c.tokenX=a.x;
                c.tokenY=a.y;
                if (a.rotation != null) {
                    c.rotation=a.rotation;
                    update["positions."+c.id] = {tokenX:a.x, tokenY:a.y, rotation:a.rotation};
                } else {
                    update["positions."+c.id] = {tokenX:a.x, tokenY:a.y, rotation:(c.rotation!=null)?c.rotation:null};
                }
            }
        }
        if (this.campaignVersion) {
            this.combatants=combatants;
            campaign.updateAdventure(update);
            this.eventSync.emit("change");
        } else {
            this.changeCombatants(combatants);
        }
    }

    hoverChange(index) {
        if (this.hoverIndex  != index) {
            this.hoverIndex = index;
            this.eventSync.emit("change");
        }
    }

    getMapDetails(mapName, gmVersion) {
        const settings = campaign.getGameState();
        const names = settings.names||"full";
        const shared = ((settings.sharing||"readonly")=="open");
        const retDead = [], retActive=[], retInactive = [], retTurn=[], retObj=[], retMove=[], retMoveObj=[];
        const retAll = [];
        const playerView = this.playerView;

        let num=1;
        for (let i in this.combatants) {
            const c=this.combatants[i];
            let cnum=null;
    
            if ((c.ctype != "object") && (!c.state || (c.state=="active")) && !c.hidden) {
                cnum=num;
                num++;
            }
    
            if (((c.tokenMap||"").toLowerCase() == mapName) && (!c.hidden || !playerView)) {
                const info = {
                    id:c.id, 
                    index:Number(i),
                    number:cnum,
                    canMove:true,
                    hideName:c.hideName,
                    ctype:c.ctype,
                    type:c.type,
                    hidden:c.hidden,
                    tokenX:c.tokenX,
                    tokenY:c.tokenY,
                    height:c.height,
                    width:c.width,
                    diameter:c.diameter,
                    fill:c.fill,
                    opacity:c.opacity,
                    currentTurn:c.currentTurn,
                    rotation:c.rotation,
                    select:this.selected[c.id],
                    hover:i==this.hoverIndex,
                    extraOffset:c.extraOffset,
                    showNames:names,
                    startPos:c.startPos,
                    anchorId:c.anchorId,
                    target:c.target,
                    actionInfo:c.actionInfo
                };

                Object.assign(info, getTokenInfo(c));
                info.area = computeArea(info);
                if (info.tokenType=="nametoken") {
                    delete info.rotation;
                }

                if (this.readonly) {
                    info.canMove = false;
                } else if (playerView) {
                    switch (c.ctype) {
                        case "object":{
                            if (!c.playerControlled) {
                                // objects that are not player controlled cannot be moved by players
                                info.canMove = false;
                            } else {
                                info.player = !!campaign.getMyCharacterInfo(c.characterName);
                            }
                            break;
                        }
                        case "pc":
                        case "cmonster": {
                            if (!shared) {
                                // if not shared then you can only move your own characters
                                info.canMove = !!campaign.getMyCharacterInfo(c.name);
                            }
                            info.player = info.canMove;
                            break;
                        }
                        default:
                            info.canMove = false;
                            break;
                    }
                }

                info.listening = info.canMove;
                if (gmVersion && info.canMove && !info.select && (c.ctype=="object")) {
                    info.listening = (c.showAsToken && !c.target);
                }

                let ret;
                let order;
                if (info.select || c.showAsToken || info.target) {
                    if (!info.select && (c.ctype == "object")) {
                        if (!c.anchorId) {
                            ret=retMoveObj;
                            order = 4;
                        } else {
                            order = 2;
                            ret=retObj;
                        }
                    } else {
                        ret=retMove;
                        order =6;
                    }
                } else if (c.ctype == "object") {
                    ret = retObj;
                    order =0;
                } else {
                    switch (c.state) {
                        case "inactive":
                            ret = retInactive;
                            order =2;
                            break;
                        case "active":
                        default:
                            if (c.type && (info.hp==0)) {
                                ret = retDead;
                                order=1;
                            } else {
                                ret = retActive;
                                order =3;
                            }
                            break;
                    }

                    if (c.currentTurn) {
                        ret = retTurn;
                        order =5;
                    }
                }

                info.order = order;
                retAll.push(info)
                ret.push(info);
            }
        }
        //console.log("combatants",retObj.concat(retDead,retInactive,retActive,retTurn,retMoveObj,retMove));
        //return retObj.concat(retDead,retInactive,retActive,retMoveObj,retTurn,retMove);
        retAll.sort(function(a,b){
            let diff;
            if (!a.order || !b.order) {
                diff=a.order-b.order;
            }
            if (!diff) {
                diff = b.area-a.area;
            }
            if (!diff) {
                diff=a.order-b.order;
            }
            return diff;
        });
        //console.log("sorted combatants", retAll, this.combatants);
        return retAll;
    }

    getSelection() {
        return this.selected;
    }

    getSingleSelection() {
        let sel;
        for (let i in this.selected) {
            if (!sel) {
                sel = i;
            } else {
                return null;
            }
        }
        if (sel) {
            return this.getCombatant(sel)||null;
        }
        return null;
    }

    findTarget(cInfo) {
        for (let c of this.combatants) {
            if (c.target && ((c.characterName==cInfo.name)||(c.monsterId==cInfo.type))) {
                return c;
            }
        }
    }

    hasSelection() {
        for (let i in this.selected) {
            return i;
        }
        return false;
    }

    hasMultiSelection() {
        let count=0;
        for (let i in this.selected) {
            count++;
            if (count > 1) {
                return true;
            }
        }
        return false;
    }

    select(selList, dontReplace, dontNotify) {
        //console.log("update selection", selList, dontReplace, dontNotify);
        if (!dontReplace) {
            this.selected = {};
        }else {
            this.selected = Object.assign({},this.selected);
        }
        if (selList) {
            for (let s of selList) {
                this.selected[s]=true;
            }
        }
        this.eventSync.emit("change",dontNotify);
    }

    unselect(id) {
        delete this.selected[id];
        this.eventSync.emit("change");
    }

    isSelected(id) {
        return !!this.selected[id];
    }

    addMonsters(selList, mapPos, monsterTokens,updateSelection) {
        const combatants = (this.combatants||[]).concat([]);

        addMonsters(combatants, selList, mapPos, mapPos.mapName,null, monsterTokens);
        this.changeCombatants(combatants);
    }
}

function computeArea(c) {
    switch (c.tokenType) {
        case "nametoken":
            const crow = new Combatant(c);
            return Math.pow(((sizeScaleMap[crow.size]||0)*5),2);
        case "cube":
            return (Number(c.width)||5)*(Number(c.width)||5);
        case "line":
            return (Number(c.width)||5)*5;
        case "cone":
            return (Number(c.width)||5)*(Number(c.width)||5)/2;
        case "circle":
        case "cylinder":
        case "sphere":
            const radius = (c.tokenType=="circle")?((c.diameter||5)/2):(c.width||2.5)
            return Math.PI*radius*radius;
        case "image":
        case "imagetoken":
        case "rectangle":
            return (Number(c.height)||5)*(Number(c.width)||5);
    }
    return 0;
}

export {
    EncounterCombatants
};